<template>
  <img v-if="folder" class="icon icon-folder" src="../../../../assets/img/icons/folder.svg" alt="folder">
  <img
    v-else-if="name.match(/^.*\.(doc|DOC|docx|DOCX)$/)"
    class="icon"
    src="../../../../assets/img/icons/doc.svg"
    alt=".doc"
  >
  <img
    v-else-if="name.match(/^.*\.(xls|XLS|xlsx|XLSX)$/)"
    class="icon"
    src="../../../../assets/img/icons/xls.svg"
    alt=".xls"
  >
  <img
    v-else-if="name.match(/^.*\.(ppt|PPT|pptx|PPTX)$/)"
    class="icon"
    src="../../../../assets/img/icons/ppt.svg"
    alt=".ppt"
  >
  <img
    v-else-if="name.match(/^.*\.(pdf|PDF)$/)"
    class="icon"
    src="../../../../assets/img/icons/pdf.svg"
    alt=".pdf"
  >
  <img
    v-else-if="name.match(/^.*\.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/)"
    class="icon"
    src="../../../../assets/img/icons/img.svg"
    alt=".img"
  >
  <img v-else class="icon" src="../../../../assets/img/icons/file.svg" alt="unknown file">
</template>

<script>
export default {
  props: ['folder', 'name']
};
</script>

<style scoped lang="scss">
.icon-folder {
  height: 14px !important;
  width: 18px !important;
}
</style>
